/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { ContactsBody } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSettingsContacts: build.query<ContactsBody, void>({
      query: () => ({ method: 'GET', url: `/v1/settings/contacts` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getSettingsContactsApi };
export const { useGetSettingsContactsQuery, useLazyGetSettingsContactsQuery } = injectedRtkApi;
